<button
  class="toggle-chip"
  type="button"
  [ngClass]="size()"
  [class.active]="active()"
  [class.full-width]="fullWidth()"
  [attr.aria-pressed]="active()"
  [attr.aria-label]="showLabel() ? null : label()"
  [attr.title]="showLabel() ? null : label()"
  [style.--chip-color]="color()"
  (click)="clicked.emit()"
>
  @if (currentIcon(); as chipIcon) {
    <ptl-icon [icon]="chipIcon" [size]="size()" [strokeWidth]="1.5" [color]="'currentColor'"></ptl-icon>
  }
  @if (showLabel()) {
    {{ label() }}
  }
</button>
